import React, { FC } from 'react';
import { useClsAddressTypesQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface AddressType extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const AddressTypes: FC<AddressType> = ({ label, error, control, name, rules }) => {
  const { data } = useClsAddressTypesQuery();
  return (
    <Select
      label={label}
      data={(data && data.addressTypes) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default AddressTypes;
